var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4598 3.5475C12.3275 3.41494 12.148 3.34045 11.9607 3.34045C11.7735 3.34045 11.5939 3.41494 11.4617 3.5475L8.00016 7.00193L4.53865 3.54042C4.4064 3.40787 4.22685 3.33337 4.0396 3.33337C3.85236 3.33337 3.6728 3.40787 3.54055 3.54042C3.26448 3.81649 3.26448 4.26245 3.54055 4.53852L7.00206 8.00004L3.54055 11.4615C3.26448 11.7376 3.26448 12.1836 3.54055 12.4597C3.81662 12.7357 4.26258 12.7357 4.53865 12.4597L8.00016 8.99814L11.4617 12.4597C11.7377 12.7357 12.1837 12.7357 12.4598 12.4597C12.7358 12.1836 12.7358 11.7376 12.4598 11.4615L8.99827 8.00004L12.4598 4.53852C12.7288 4.26953 12.7288 3.81649 12.4598 3.5475Z",
    fill: "#84849A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c49741a9.svg";
export { ForwardRef as ReactComponent };